import { render } from "./Marker.vue?vue&type=template&id=648e4cb0&scoped=true"
import script from "./Marker.vue?vue&type=script&lang=js"
export * from "./Marker.vue?vue&type=script&lang=js"

import "./Marker.vue?vue&type=style&index=0&id=648e4cb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648e4cb0"],['__file',"src/common/components/Marker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "648e4cb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('648e4cb0', __exports__)) {
    api.reload('648e4cb0', __exports__)
  }
  
  module.hot.accept("./Marker.vue?vue&type=template&id=648e4cb0&scoped=true", () => {
    api.rerender('648e4cb0', render)
  })

}


export default __exports__